/* Dawn Bands theme enhancements — cleantt
   1. Image loading hygiene: stops 30+ eager images competing and dribbling in over ~7s.
   2. Instruction-manual quick links: GemPages emitted hrefs pointing at IDs that do not exist
      (and duplicated one), so nothing scrolled. Repaired by matching link text to heading text,
      which survives GemPages republishing the UIDs.
*/
(function () {
  'use strict';

  /* ---------- 1. image loading ---------- */
  function tuneImages() {
    var imgs = Array.from(document.images);
    if (!imgs.length) return;
    var fold = window.innerHeight * 1.25;

    imgs.forEach(function (img) {
      if (img.dataset.dawnTuned) return;
      img.dataset.dawnTuned = '1';

      var box = img.getBoundingClientRect();
      var aboveFold = box.top < fold;

      if (aboveFold) {
        // Visible immediately: let it race, and flag the first one as the LCP candidate.
        img.setAttribute('decoding', 'sync');
        if (!img.dataset.dawnHero && box.top < window.innerHeight && box.width > 200) {
          img.dataset.dawnHero = '1';
          img.setAttribute('fetchpriority', 'high');
          img.removeAttribute('loading');
        }
      } else {
        // Below the fold: defer so it stops competing with what the shopper can actually see.
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        img.setAttribute('fetchpriority', 'low');
      }

      // Reserve space so late arrivals don't reflow the page.
      var w = img.getAttribute('width');
      var h = img.getAttribute('height');
      var missing = !w || !h || w === 'auto' || h === 'auto';
      if (missing && !img.style.aspectRatio) {
        var ratio = ratioFromSrc(img.currentSrc || img.src);
        if (ratio) img.style.aspectRatio = ratio;
      }

      correctSizes(img, box);
    });
  }

  /* GemPages hardcodes sizes="100vw" on gallery thumbnails that render ~83px wide, so the
     browser picks the 1024w candidate — a ~1041px file for an 83px thumb. These are lazyloaded,
     so correcting `sizes` before the loader swaps src actually prevents the oversized fetch. */
  function correctSizes(img, box) {
    if (!img.getAttribute('srcset')) return;
    if (img.complete && img.naturalWidth > 0) return; // already fetched; changing sizes just re-downloads
    var shown = Math.round(box.width);
    if (!shown || shown > window.innerWidth * 0.6) return; // genuinely full-bleed, leave alone
    var declared = img.getAttribute('sizes') || '';
    if (declared && !/100vw|auto/.test(declared)) return; // author set something specific
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    img.setAttribute('sizes', Math.ceil(shown * dpr) + 'px');
    img.dataset.dawnSized = shown;
  }

  // Shopify CDN URLs carry the master dimensions; use them to reserve space.
  function ratioFromSrc(src) {
    if (!src) return null;
    var m = src.match(/[?&]width=(\d+)/);
    var d = src.match(/_(\d{2,4})x(\d{2,4})[._]/);
    if (d) return d[1] + ' / ' + d[2];
    if (m) return null;
    return null;
  }

  /* ---------- 2. instruction-manual quick links ---------- */
  function leadingNumber(s) {
    var m = (s || '').trim().match(/^(\d+)\s*\./);
    return m ? m[1] : null;
  }

  function repairQuickLinks() {
    var links = Array.from(document.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    var headings = Array.from(document.querySelectorAll('h1,h2,h3')).filter(function (h) {
      return leadingNumber(h.textContent);
    });
    if (!headings.length) return;

    var byNumber = {};
    headings.forEach(function (h) {
      var n = leadingNumber(h.textContent);
      if (n && !byNumber[n]) byNumber[n] = h;
    });

    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href === '#' || href.length < 2) return;
      var id = href.slice(1);
      // Only touch links whose target is genuinely missing — never hijack working anchors.
      if (document.getElementById(id)) return;

      var n = leadingNumber(a.textContent);
      var target = n ? byNumber[n] : null;
      if (!target) return;

      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        scrollToWithOffset(target);
      });
      a.dataset.dawnRepaired = n;
    });
  }

  function stickyOffset() {
    var candidates = document.querySelectorAll('sticky-header, .header-wrapper, header');
    var max = 0;
    candidates.forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        max = Math.max(max, el.getBoundingClientRect().height);
      }
    });
    return max + 16;
  }

  function scrollToWithOffset(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- 3. MoonBundle tier price display ----------
     Bundle rows stack three numbers (per-each, combined subtotal, combined
     compare-at). The subtotal is hidden by CSS; here the crossed compare-at is
     rewritten from the combined figure to the per-each figure so each tier reads
     "$X.XX /each  ~$69.00~". Svelte re-renders on tier selection, so a
     MutationObserver re-applies. */
  function fixBundleCompareAt() {
    var mb = document.querySelector('moonbundle-component');
    if (!mb) return;
    // The per-band anchor is whatever the Single row crosses out; bundle rows
    // are forced to show the same figure. Idempotent, so re-renders and repeat
    // passes can't compound (a ratio-based guard mis-fired when the anchor
    // exceeded the bundle subtotal).
    var anchor = null;
    mb.querySelectorAll('.moonbundle-offer-wrapper').forEach(function (row) {
      if (!row.querySelector('.moonbundle-option-single-price')) {
        var o = row.querySelector('.moonbundle-option-old-price');
        var v = o && (o.textContent.match(/[\d.,]+/) || [])[0];
        if (v && !anchor) anchor = o.textContent.trim();
      }
    });
    if (!anchor) return;
    mb.querySelectorAll('.moonbundle-offer-wrapper').forEach(function (row) {
      if (!row.querySelector('.moonbundle-option-single-price')) return;
      var old = row.querySelector('.moonbundle-option-old-price');
      if (old && old.textContent.trim() !== anchor) old.textContent = anchor;
    });
  }
  function watchBundlePrices() {
    var mb = document.querySelector('moonbundle-component');
    if (!mb) return;
    fixBundleCompareAt();
    new MutationObserver(function () { fixBundleCompareAt(); })
      .observe(mb, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    try { tuneImages(); } catch (e) {}
    try { repairQuickLinks(); } catch (e) {}
    try { watchBundlePrices.__done || (watchBundlePrices.__done = 1, watchBundlePrices()); } catch (e) {}
    try { fixBundleCompareAt(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // GemPages and app blocks inject content after load; re-run a few times, then stop.
  var passes = 0;
  var iv = setInterval(function () {
    passes++;
    init();
    if (passes >= 6) clearInterval(iv);
  }, 900);
})();
